import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
const TOKENS_KEY = "bb_session_tokens";
let refreshing = null;

export const tokens = {
  get: () => { try { return JSON.parse(sessionStorage.getItem(TOKENS_KEY)) || {}; } catch { return {}; } },
  set: (t) => { if (t?.access_token) sessionStorage.setItem(TOKENS_KEY, JSON.stringify({ ...tokens.get(), ...t })); },
  clear: () => sessionStorage.removeItem(TOKENS_KEY),
};

export const authHeaders = () => {
  const a = tokens.get().access_token;
  return a ? { Authorization: `Bearer ${a}` } : {};
};

api.interceptors.request.use((config) => {
  const h = authHeaders();
  if (h.Authorization && !config.headers.Authorization) config.headers.Authorization = h.Authorization;
  return config;
});

const refreshSession = () => {
  refreshing = refreshing || api.post("/auth/refresh", { refresh_token: tokens.get().refresh_token })
    .then((r) => { if (r.data?.access_token) tokens.set({ access_token: r.data.access_token }); return r; })
    .finally(() => (refreshing = null));
  return refreshing;
};

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 402 && !window.location.pathname.startsWith("/billing")) {
      window.location.assign("/billing");
    }
    if (error.response?.status === 401 && !orig._retry && !NO_RETRY.some((u) => orig.url.includes(u))) {
      orig._retry = true;
      try {
        await refreshSession();
        delete orig.headers.Authorization;
        return api(orig);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export async function streamPost(path, body, onText) {
  const doFetch = () =>
    fetch(`${API}${path}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify(body),
    });
  let res = await doFetch();
  if (res.status === 401) {
    await refreshSession();
    res = await doFetch();
  }
  if (res.status === 402) window.location.assign("/billing");
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(typeof j.detail === "string" ? j.detail : "Request failed");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let full = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const d = JSON.parse(p.slice(6));
      if (d.error) throw new Error(d.error);
      if (d.t) {
        full += d.t;
        onText(full);
      }
    }
  }
  return full;
}
